import { Components, Theme } from '@mui/material/styles'

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: 'auto',
      height: 'auto',
      padding: 8,
      backgroundColor: 'transparent',
      borderRadius: 8,
      color: theme.palette.text.primary,

      ':hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },

      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
        backgroundColor: 'transparent',
      },
    }),
  },
}

declare module '@mui/material/IconButton' {
  // interface IconButtonPropsColorOverrides {}
}
